import {Box, Card, CardContent, Grid, Typography} from "@deere/fuel-react";
import React, {useEffect} from "react";
import {getCategoryTotal, getCategoryWeightTotal, getTotalSelected} from "../shared/utils";

export const RatingPgmCriteriaSummaryCard = (props) => {
    useEffect(() => {
            props.selectedSubCategories.forEach(item => {
                getTotalSelected(props.currentData, item.id)
            })
        },// eslint-disable-next-line react-hooks/exhaustive-deps
        [props.currentData])

    return <Card>
        <CardContent style={{padding: 0}}>
            <Box m={4}>
                <Grid container alignItems="flex-start" spacing={1}>
                    <Grid item xs={10}>
                        <Box mt={3} ml={3} mr={3}>
                            <Typography variant="h3">
                                {props.categoryName}
                            </Typography>
                        </Box>
                    </Grid>
                    <Grid item xs={1}>
                        <Box mt={3} ml={3} mr={3} display="flex" justifyContent="center">
                            <Typography variant="h3">
                                {getCategoryTotal(props.currentData, props.categoryId)}
                            </Typography>
                        </Box>
                    </Grid>
                    <Grid item xs={1}>
                        <Box mt={3} ml={3} mr={3} display="flex" justifyContent="center">
                            <Typography variant="h3">
                                {`${getCategoryWeightTotal(props.currentData, props.categoryId)}%`}
                            </Typography>
                        </Box>
                    </Grid>
                    {props.currentData.category.filter(ele => ele.id === props.categoryId)[0].isNot100Error && (
                        <Grid item xs={12}>
                            <Box display="flex" justifyContent="flex-end">
                                <Typography color="error" size="xs">
                                    Category total should be 100
                                </Typography>
                            </Box>
                        </Grid>
                    )}
                    {props.selectedSubCategories.length > 0 && props.selectedSubCategories.map((item, index) => {
                        return (
                            <React.Fragment key={index}>
                                <Grid item xs={10}>
                                    <Box ml={3} m={0.5}>
                                        <Typography variant="label">
                                            {item.description}
                                        </Typography>
                                    </Box>
                                </Grid>
                                <Grid item xs={1}>
                                    <Box m={0.5} display="flex" justifyContent="center">
                                        <Typography variant="label">
                                            {getTotalSelected(props.currentData, item.id)}
                                        </Typography>
                                    </Box>
                                </Grid>
                                <Grid item xs={1}>
                                    <Box m={0.5} display="flex" justifyContent="center">
                                        <Typography variant="label">
                                            {`${item.weight}%`}
                                        </Typography>
                                    </Box>
                                </Grid>
                            </React.Fragment>
                        )
                    })}
                </Grid>
            </Box>
        </CardContent>
    </Card>;
}
